<template>
  <div id="page-header" class="clear" >
    <div id="logo-box"></div>
    <div class="header-client-name">
      <h4></h4>
    </div>
    <div class="header-client-profile clear">
      <div class="client-photo" :style=" { backgroundColor: companyPrimaryColor + '22' }"><p :style=" { color: companyPrimaryColor }">{{ userAbb }}</p></div>
      <div class="user-menu">
        <div class="user-menu-name">
          <p class="client-name">Welkom {{ user }} </p>
          <div class="user-menu-arrow"></div>
        </div>
        <div class="user-menu-item-wrapper">
          <router-link :to="`/users`" class="user-menu-item" v-if="userRole === 'Admin'">Gebruikers beheren</router-link>
          <!-- <a class="user-menu-item">Profiel bijwerken</a> -->
          <a class="user-menu-item" @click="logout()">Uitloggen</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Header",
  data: () => ({}),
  methods: {
    logout() {
      this.$store.dispatch("userLogout");
    }
  },

  computed: {
    user() {
      return this.$store.state.userFirstName;
    },
    userAbb() {
      return this.$store.state.userAbb;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    }
  }
};
</script>
